import { render, staticRenderFns } from "./modalHistorialPazSalvo.vue?vue&type=template&id=4910ba36&scoped=true"
import script from "./modalHistorialPazSalvo.vue?vue&type=script&lang=js"
export * from "./modalHistorialPazSalvo.vue?vue&type=script&lang=js"
import style0 from "./modalHistorialPazSalvo.vue?vue&type=style&index=0&id=4910ba36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4910ba36",
  null
  
)

export default component.exports